const STORAGE_KEY = "hsCorseTuningPricingDraft";

function loadPricingDraft() {
  try {
    if (typeof window === "undefined" || !window.localStorage) {
      return {};
    }

    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}

const pricingDraft = loadPricingDraft();

const DYNO_PRICE = pricingDraft.dynoPrice ?? 100;
const GIULIA_STELVIO_DYNO_PRICE = pricingDraft.giuliaStelvioDynoPrice ?? 125;

const TCT_DYNO_MESSAGE =
  "Bij TCT modellen is rollenbankmeting niet mogelijk. De tuning wordt op basis van logging en softwarematig maatwerk uitgevoerd.";

const EXTRA_PRICES = pricingDraft.extraPrices ?? {
  popsAndBangs: 175,
  popsAndBangsAbarthEuro6SportButton: 275,
  popsAndBangsGiuliaStelvioDynamic: 350,
  launchControlFlatshift: 175,
  startStopDisable: 0,
  mtaTuning: 290,
  tctTuning: 290,
  zf8Tuning: 290
};

const TUNING_PRICES = pricingDraft.tuningPrices ?? {
  abarth595: {
    label: "Abarth 500 / 595 / 695",
    variants: {
      euro5: {
        label: "Euro 5",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 690 }
        }
      },
      euro6: {
        label: "Euro 6",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 530 },
          stage2plus: { label: "Stage 2+", price: 590 },
          stage3: { label: "Stage 3", price: 740 },
          stage3plus: { label: "Stage 3+", price: 790 }
        }
      }
    }
  },
  abarth124Spider: {
    label: "Abarth 124",
    variants: {
      multiair170: {
        label: "1.4 MultiAir 170 pk",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 530 }
        }
      }
    }
  },
  abarthPuntoEvo: {
    label: "Abarth Punto EVO",
    variants: {
      multiair163: {
        label: "1.4 MultiAir 163 pk",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 690 }
        }
      },
      multiair180: {
        label: "1.4 MultiAir 180 pk",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 690 }
        }
      }
    }
  },
  grandePuntoAbarth: {
    label: "Grande Punto Abarth",
    variants: {
      tjet155: {
        label: "1.4 T-Jet 155 pk",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 690 }
        }
      },
      tjet180: {
        label: "1.4 T-Jet 180 pk",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 690 }
        }
      }
    }
  },
  alfaMito: {
    label: "Alfa MiTo",
    variants: {
      tjet120: {
        label: "T-Jet 120 pk",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 670 }
        }
      },
      tjet150: {
        label: "T-Jet 150 pk",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 670 }
        }
      },
      multiair135: {
        label: "MultiAir 135 pk",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 690 }
        }
      },
      multiair170Euro5: {
        label: "MiTo QV MultiAir 170 pk Euro 5",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 490 },
          stage2plus: { label: "Stage 2+", price: 560 },
          stage3: { label: "Stage 3", price: 690 }
        }
      },
      multiair170Euro6: {
        label: "MiTo QV MultiAir 170 pk Euro 6",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 530 },
          stage2plus: { label: "Stage 2+", price: 590 },
          stage3: { label: "Stage 3", price: 740 }
        }
      }
    }
  },
  alfaGiulietta: {
    label: "Alfa Giulietta",
    variants: {
      tjet120Euro5: {
        label: "1.4 T-Jet 120 pk Euro 5",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 530 },
          stage2plus: { label: "Stage 2+", price: 560 }
        }
      },
      tjet120Euro6: {
        label: "1.4 T-Jet 120 pk Euro 6",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 530 },
          stage2plus: { label: "Stage 2+", price: 570 }
        }
      },
      multiair14Euro5: {
        label: "1.4 MultiAir Euro 5",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 460 },
          stage2: { label: "Stage 2", price: 530 },
          stage2plus: { label: "Stage 2+", price: 560 }
        }
      },
      multiair14Euro6: {
        label: "1.4 MultiAir Euro 6",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 530 },
          stage2plus: { label: "Stage 2+", price: 570 }
        }
      },
      qvTbiEuro5: {
        label: "QV 1750 TBi Euro 5",
        dynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 530 },
          stage2plus: { label: "Stage 2+", price: 590 },
          stage3: { label: "Stage 3", price: 690 }
        }
      },
      qvTbiTctEuro6: {
        label: "QV 1750 TBi TCT Euro 6",
        gearbox: "TCT",
        dynoAllowed: true,
        tctDynoAllowed: true,
        stages: {
          stage1: { label: "Stage 1", price: 560 },
          stage2: { label: "Stage 2", price: 590 },
          stage2plus: { label: "Stage 2+", price: 650 },
          stage3: { label: "Stage 3", price: 740 }
        }
      }
    }
  },
  alfaGiulia: {
    label: "Alfa Giulia 2.0T",
    gearbox: "ZF8",
    dynoAllowed: true,
    variants: {
      hp200: {
        label: "2.0T 200 pk",
        gearbox: "ZF8",
        dynoAllowed: true,
        dynoPrice: GIULIA_STELVIO_DYNO_PRICE,
        stages: {
          stage1: { label: "Stage 1", price: 590 },
          stage2: { label: "Stage 2", price: 630 },
          stage2plus: { label: "Stage 2+", price: 690 }
        }
      },
      hp280: {
        label: "2.0T 280 pk",
        gearbox: "ZF8",
        dynoAllowed: true,
        dynoPrice: GIULIA_STELVIO_DYNO_PRICE,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 630 },
          stage2plus: { label: "Stage 2+", price: 690 }
        }
      },
      hp280Opf: {
        label: "2.0T 280 pk EU6D OPF",
        gearbox: "ZF8",
        dynoAllowed: true,
        dynoPrice: GIULIA_STELVIO_DYNO_PRICE,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 630 },
          stage2plus: { label: "Stage 2+", price: 690 }
        }
      }
    }
  },
  alfaStelvio: {
    label: "Alfa Stelvio 2.0T",
    gearbox: "ZF8",
    dynoAllowed: true,
    variants: {
      hp200: {
        label: "2.0T 200 pk",
        gearbox: "ZF8",
        dynoAllowed: true,
        dynoPrice: GIULIA_STELVIO_DYNO_PRICE,
        stages: {
          stage1: { label: "Stage 1", price: 590 },
          stage2: { label: "Stage 2", price: 630 },
          stage2plus: { label: "Stage 2+", price: 690 }
        }
      },
      hp280: {
        label: "2.0T 280 pk",
        gearbox: "ZF8",
        dynoAllowed: true,
        dynoPrice: GIULIA_STELVIO_DYNO_PRICE,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 630 },
          stage2plus: { label: "Stage 2+", price: 690 }
        }
      },
      hp280Opf: {
        label: "2.0T 280 pk EU6D OPF",
        gearbox: "ZF8",
        dynoAllowed: true,
        dynoPrice: GIULIA_STELVIO_DYNO_PRICE,
        stages: {
          stage1: { label: "Stage 1", price: 490 },
          stage2: { label: "Stage 2", price: 630 },
          stage2plus: { label: "Stage 2+", price: 690 }
        }
      }
    }
  }
};

const DYNO_RULES = {
  stage1: "optional",
  stage2: "optional",
  stage2plus: "optional",
  stage3: "required",
  stage3plus: "required",
  stage4: "required",
  turboUpgrade: "required"
};

const TRANSMISSION_DYNO_ALLOWED = {
  manual: true,
  automatic: true,
  mta: true,
  tct: false,
  zf8: true
};

function getTuningPrice(vehicleId, variantId, stageId) {
  const vehicle = TUNING_PRICES[vehicleId];
  if (!vehicle) {
    return {
      ok: false,
      error: `Onbekend voertuig: ${vehicleId}`,
      softwarePrice: null
    };
  }

  const variant = vehicle.variants?.[variantId];
  if (!variant) {
    return {
      ok: false,
      error: `Onbekende variant voor ${vehicle.label}: ${variantId}`,
      softwarePrice: null
    };
  }

  const stage = variant.stages?.[stageId];
  if (!stage) {
    return {
      ok: false,
      error: `Onbekende stage voor ${vehicle.label} ${variant.label}: ${stageId}`,
      softwarePrice: null
    };
  }

  return {
    ok: true,
    error: null,
    vehicleLabel: vehicle.label,
    variantLabel: variant.label,
    stageLabel: stage.label,
    softwarePrice: stage.price,
    dynoAllowed: variant.dynoAllowed !== false,
    dynoUnitPrice: variant.dynoPrice || vehicle.dynoPrice || DYNO_PRICE,
    tctDynoAllowed: variant.tctDynoAllowed === true,
    gearbox: variant.gearbox || vehicle.gearbox || null,
    dynoBlockedMessage: variant.dynoBlockedMessage || null
  };
}

function calculateTotalPrice({
  vehicleId,
  variantId,
  stageId,
  includeDyno = false,
  selectedExtras = []
}) {
  const tuningPrice = getTuningPrice(vehicleId, variantId, stageId);
  const selectedExtrasList = Array.isArray(selectedExtras) ? selectedExtras : [];
  const tctSelected = selectedExtrasList.includes("tctTuning") || tuningPrice.gearbox === "TCT";
  const tctBlocksDyno = tctSelected && !tuningPrice.tctDynoAllowed;
  const dynoRequired = DYNO_RULES[stageId] === "required";
  const dynoAllowed = tuningPrice.ok && tuningPrice.dynoAllowed && !tctBlocksDyno;
  const shouldAddDyno = dynoAllowed && (dynoRequired || includeDyno);
  const dynoUnitPrice = tuningPrice.dynoUnitPrice || DYNO_PRICE;
  const dynoPrice = shouldAddDyno ? dynoUnitPrice : 0;
  const extrasTotal = selectedExtrasList.reduce((total, extraId) => {
    return total + (EXTRA_PRICES[extraId] ?? 0);
  }, 0);
  const totalPrice = typeof tuningPrice.softwarePrice === "number"
    ? tuningPrice.softwarePrice + dynoPrice + extrasTotal
    : null;

  return {
    softwarePrice: tuningPrice.softwarePrice,
    dynoPrice,
    dynoUnitPrice,
    extrasTotal,
    totalPrice,
    dynoRequired,
    dynoAllowed,
    ok: tuningPrice.ok,
    error: tuningPrice.error,
    vehicleLabel: tuningPrice.vehicleLabel,
    variantLabel: tuningPrice.variantLabel,
    stageLabel: tuningPrice.stageLabel,
    gearbox: tuningPrice.gearbox,
    dynoBlockedMessage: tuningPrice.dynoBlockedMessage || (tctBlocksDyno ? TCT_DYNO_MESSAGE : null)
  };
}


const STAGE_ID_TO_PRICE_KEY = {
  stage_1: 'stage1',
  stage_2: 'stage2',
  stage_2_plus: 'stage2plus',
  stage_3: 'stage3',
  stage_3_plus: 'stage3plus',
  stage_4: 'stage4',
  turbo_upgrade: 'turboUpgrade'
};

window.HS_PRICING_CONFIG = {
  currency: 'EUR',
  taxMode: 'Verkoopadvies incl. btw',
  unknownPriceLabel: 'prijs op aanvraag',
  tuningPrices: TUNING_PRICES,
  extraPrices: EXTRA_PRICES,
  tctDynoMessage: TCT_DYNO_MESSAGE,
  getTuningPrice,
  calculateTotalPrice,
  stageIdToPriceKey: STAGE_ID_TO_PRICE_KEY,
  dyno: {
    label: 'Rollenbankgebruik incl. uitdraai',
    price: DYNO_PRICE,
    rules: {
      stage_1: DYNO_RULES.stage1,
      stage_2: DYNO_RULES.stage2,
      stage_2_plus: DYNO_RULES.stage2plus,
      stage_3: DYNO_RULES.stage3,
      stage_3_plus: DYNO_RULES.stage3plus,
      stage_4: DYNO_RULES.stage4,
      turbo_upgrade: DYNO_RULES.turboUpgrade,
      pops_bangs: 'optional',
      advice: 'optional'
    }
  },
  gearboxSoftware: {
    mta: EXTRA_PRICES.mtaTuning,
    tct: EXTRA_PRICES.tctTuning,
    zf8: EXTRA_PRICES.zf8Tuning
  },
  transmissions: {
    manual: { label: 'Handgeschakeld', dynoAllowed: true, softwareAvailable: false },
    automatic: { label: 'Automaat', dynoAllowed: true, softwareAvailable: false },
    mta: { label: 'MTA', dynoAllowed: true, softwareAvailable: true },
    tct: { label: 'TCT', dynoAllowed: false, softwareAvailable: true, dynoBlockedMessage: TCT_DYNO_MESSAGE },
    zf8: { label: 'ZF8 automaat', dynoAllowed: true, softwareAvailable: true }
  },
  formatPrice(value) {
    if (typeof value !== 'number') return this.unknownPriceLabel;
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: this.currency, maximumFractionDigits: 0 }).format(value);
  }
};
